import { makeStyles, Theme } from "@material-ui/core";

import { configs } from "../../configs";

const useExplanationStyles = makeStyles(({ palette }) => ({
  dialogContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
  },
  dialogTitle: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '32px',
    margin: '24px 0',
    textAlign: 'center',
  },
  dialogMainDescription: {
    color: 'rgba(0, 0, 0, 0.60)',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.15px',

    '& span': {
      color: 'rgba(0, 0, 0, 0.87)',
      fontWeight: 700,
    }
  },
  dialogFooterDescription: {
    color: 'rgba(0, 0, 0, 0.60)',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  dialogButton: {
    borderColor: palette.brandColor,
    color: palette.brandColor,
    fontWeight: 400,
    margin: '16px 0 0 auto',
  },
  infoText: {
    color: palette.brandColor,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    textDecoration: 'underline',
  },
  infoTextWrapper: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    gap: '4px',

    '& svg': {
      color: palette.brandColor
    }
  }
}))

const useWreathWithCaptionStyles = makeStyles<Theme, { isMobileViewOnly: boolean; }>(({ breakpoints }) => ({
  wreathContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  positionNumber: ({ isMobileViewOnly }) => ({
    color: 'rgba(0, 0, 0, 0.60)',
    textAlign: 'center',
    fontFamily: 'LatoBold',
    fontSize: '24px',
    fontWeight: 900,
    lineHeight: '36px',
    margin: '0 0 4px',

    [breakpoints.up('sm')]: isMobileViewOnly ? undefined : {
      fontSize: '40px',
      lineHeight: '60px',
      margin: '0 3px 6px',
    }
  }),
  rightSideWreath: {
    transform: 'scale(-1, 1)',
  },
  ribbonContainer: ({ isMobileViewOnly }) => ({
    minHeight: '20px',
    position: 'relative',
    margin: '0 auto',
    width: '90px',

    [breakpoints.up('sm')]: isMobileViewOnly ? undefined : {
      minHeight: '32px',
      width: '145px'
    }
  }),
  ribbonImageBase: {
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  },
  ribbonImage: {
    background: `no-repeat url(${configs.cdnUrl}/svg/label_ribbon.svg)`,
  },
  ribbonImageSmall: {
    background: `no-repeat url(${configs.cdnUrl}/svg/label_ribbon_mobile.svg)`,
  },
  ribbonTextContainer: ({ isMobileViewOnly }) => ({
    alignItems: 'center',
    display: 'flex',
    height: '20px',
    margin: '0 auto',
    paddingTop: '4px',
    position: 'relative',
    width: '73%',
    zIndex: 1,

    [breakpoints.up('sm')]: isMobileViewOnly ? undefined : {
      height: '32px',
      paddingTop: '8px',
    }
  }),
  ribbonTextBase: {
    color: '#fff',
    flex: 1,
    fontWeight: 700,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  ribbonText: ({ isMobileViewOnly }) => ({
    fontSize: '8px',
    lineHeight: '20px',

    [breakpoints.up('sm')]: isMobileViewOnly ? undefined : {
      fontSize: '12px',
      lineHeight: '16px',
    }
  }),
  ribbonTextSmall: {
    fontSize: '7px',
    lineHeight: '7px',

    [breakpoints.up('sm')]: {
      fontSize: '10px',
      lineHeight: '10px',
    }
  },
}))

export { useExplanationStyles, useWreathWithCaptionStyles }